import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorInvoiceItem = v.object({
  invoiceId: v.id("invoices"),
  productId: v.optional(v.id("products")),
  serviceId: v.optional(v.id("services")),
  name: v.string(),
  description: v.optional(v.string()),
  quantity: v.number(),
  unitPrice: v.number(),
  unit: v.string(),
  taxRate: v.number(),
  subtotal: v.number(),
  taxAmount: v.number(),
  totalAmount: v.number(),
  sortOrder: v.optional(v.number()),
  productCode: v.optional(v.string()),
  purchasePrice: v.optional(v.number()),
  type: v.optional(
    v.union(v.literal("product"), v.literal("service"), v.literal("custom")),
  ),
  notes: v.optional(v.string()),
  createdAt: v.optional(v.number()),
  updatedAt: v.optional(v.number()),

  isExempt: v.optional(v.boolean()),
  exemptRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),
  discountRate: v.optional(v.number()),
  discountAmount: v.optional(v.number()),
  internalControl: v.optional(internalControl),

  // HONDURAS SAR/SARIN COMPLIANCE - G-030: Tasa de retención ISR por ítem
  isrRetentionRate: v.optional(v.number()),
});

export const invoices_items = defineTable(validatorInvoiceItem)
  .index("by_invoice_id", ["invoiceId"])
  .index("by_sort_order", ["invoiceId", "sortOrder"])
  .index("by_product_code", ["productCode"])
  .index("by_product_id", ["productId"])
  .index("by_type", ["type"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
